import { useEffect, useState } from "react";

type Step = {
  number: number;
  label: string;
  active?: boolean;
  completed?: boolean;
};

type StepIndicatorProps = {
  currentStep: number;
};

const StepIndicator = (props: StepIndicatorProps) => {
  const baseSteps = [
    { number: 1, label: "Sign Up" },
    { number: 2, label: "Company Address" },
    { number: 3, label: "Email Verification" },
    { number: 4, label: "Done" },
  ];

  const [steps, setSteps] = useState<Step[]>(baseSteps);

  useEffect(() => {
    const updatedSteps = baseSteps.map((step) => {
      if (step.number < props.currentStep) {
        return { ...step, completed: true, active: false };
      } else if (step.number === props.currentStep) {
        return { ...step, active: true, completed: false };
      } else {
        return { ...step, active: false, completed: false };
      }
    });
    setSteps(updatedSteps);
  }, [props.currentStep]);

  return (
    <div className="mb-8">
      <div className="relative flex items-start justify-between">
        {/* Continuous horizontal line - positioned at circle center */}
        <div className="absolute left-2 right-2 top-4">
          <div className="w-full h-0.5 bg-gray-200"></div>
        </div>
        {steps.map((step) => (
          <div
            key={step.number}
            className="relative flex flex-col items-center"
          >
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center text-sm font-medium ${
                step.completed
                  ? "bg-green-500 text-white"
                  : step.active
                  ? "bg-slate-800 text-white"
                  : "bg-gray-200 text-gray-500"
              }`}
            >
              {step.completed ? "✓" : step.number}
            </div>
            <span className="text-xs mt-2 text-center max-w-20 h-8 flex items-start">
              {step.label}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default StepIndicator;
